<template>
  <v-form ref="form" @submit.prevent="$emit('submit')">
    <v-row>
      <v-col>
        <h4>General information</h4>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          slim
          name="name"
        >
          <v-text-field
            v-model="lottery.name"
            label="Name"
            name="name"
            :error-messages="errors"
            type="text"
          >
          </v-text-field>
        </validation-provider>

	      <validation-provider
		      v-slot="{ errors }"
		      rules="required"
		      slim
		      name="timezone"
	      >
		      <v-autocomplete
			      v-model="lottery.timezone"
			      :items="params.timezones"
			      item-value="timezone"
			      item-text="timezone"
			      label="Timezone"
		      >
		      </v-autocomplete>
	      </validation-provider>
	      <validation-provider
		      v-slot="{ errors }"
          rules="required"
          slim
          name="logo"
        >
          <v-row>
            <v-col>
              <v-file-input
                v-model="lottery.logo"
                label="Logo"
                name="logo"
                :error-messages="errors"
              >
              </v-file-input>
            </v-col>
            <v-col>
              <v-img v-if="logoSrc" :max-width="150" :src="logoSrc"></v-img>
            </v-col>
          </v-row>
        </validation-provider>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <input type="submit" hidden />
  </v-form>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules.js";

extend("required", {
  ...required,
  message: "This field is required"
});

export default {
  name: "LotteryForm",
  components: {
    ValidationProvider
  },
  model: {
    prop: "lottery"
  },
  props: {
    lottery: {
      type: Object,
      required: false,
      default: () => ({}),
      description: "The lottery to be manipulated."
    },
	  params: {
    	type: Object,
		  required: false,
		  default: () => ({}),
		  description: "The timezones required for the select"
	  }
  },
  data() {
    return {
      logoSrc: ""
    };
  },
  watch: {
    "lottery.logo"() {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.logoSrc = reader.result;
      };
      if (this.lottery.logo && this.lottery.logo.name) {
        reader.readAsDataURL(this.lottery.logo);
      } else if (this.lottery.logo) {
        this.logoSrc = this.lottery.logo.normal.url;
      }
    }
  }
};
</script>

<style scoped></style>
